export const apsas = [
  {
    "titulo_item_nombre": "Apoyos y Subsidios 2026",
    "archivos": [
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "1ER. TRIMESTRE 2026",
        "file_item_url": "../../contenido/transparencia/apsas/2026/1ER. TRIMESTRE 2026.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "2DO. TRIMESTRE 2026",
        "file_item_url": "../../contenido/transparencia/apsas/2026/2DO. TRIMESTRE 2026.pdf"
      },
    ]
  },
  {
    "titulo_item_nombre": "Apoyos y Subsidios 2025",
    "archivos": [
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "1ER. TRIMESTRE 2025",
        "file_item_url": "../../contenido/transparencia/apsas/2025/1ER. TRIMESTRE 2025.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "2DO. TRIMESTRE 2025",
        "file_item_url": "../../contenido/transparencia/apsas/2025/2DO. TRIMESTRE 2025.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "3ER. TRIMESTRE 2025",
        "file_item_url": "../../contenido/transparencia/apsas/2025/3ER. TRIMESTRE 2025.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "4TO. TRIMESTRE 2025",
        "file_item_url": "../../contenido/transparencia/apsas/2025/4TO. TRIMESTRE 2025.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "Apoyos y Subsidios 2024",
    "archivos": [
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "1ER. TRIMESTRE 2024",
        "file_item_url": "../../contenido/transparencia/apsas/2024/1ER. TRIMESTRE 2024.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "2DO. TRIMESTRE 2024",
        "file_item_url": "../../contenido/transparencia/apsas/2024/2DO. TRIMESTRE 2024.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "3ER. TRIMESTRE 2024",
        "file_item_url": "../../contenido/transparencia/apsas/2024/3ER. TRIMESTRE 2024.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "4TO. TRIMESTRE 2024",
        "file_item_url": "../../contenido/transparencia/apsas/2024/4TO. TRIMESTRE 2024.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "Apoyos y Subsidios 2023",
    "archivos": [
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "1ER. TRIMESTRE 2023",
        "file_item_url": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/ServSaludH/articulo69/fracc15/A/2023/1-er-t-2023/PADRON%20ENERO-MARZO%202023.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "2DO. TRIMESTRE 2023",
        "file_item_url": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/ServSaludH/articulo69/fracc15/A/2023/2do-t-2023/PADRON%20ABRIL-JUNIO%2023.pdf "
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "3ER. TRIMESTRE 2023",
        "file_item_url": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/ServSaludH/articulo69/fracc15/B/PADRON%203ER%20TRIMESTRE.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "4TO. TRIMESTRE 2023",
        "file_item_url": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/ServSaludH/articulo69/fracc15/A/2023/4to-trim-2023/PADRON%20OCT-DIC%2023.pdf"
      }
    ]
  },
  {
    "titulo_item_nombre": "Apoyos y Subsidios 2022",
    "archivos": [
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "1ER. TRIMESTRE 2022",
        "file_item_url": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/ServSaludH/articulo69/fracc15/A/PADRON%20ENE%20MZO%202022.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "2DO. TRIMESTRE 2022",
        "file_item_url": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/ServSaludH/articulo69/fracc15/A/2do-t-22/PADRON%20DE%20BENEFICIARIOS%20ABRIL-JUNIO%202022.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "3ER. TRIMESTRE 2022",
        "file_item_url": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/ServSaludH/articulo69/fracc43/A/2DO-T-2022/PADRON%20JUL%20SEPT%202022.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "4TO. TRIMESTRE 2022",
        "file_item_url": "http://transparenciadocs.hidalgo.gob.mx/ENTIDADES/ServSaludH/articulo69/fracc15/A/PADRON%20OCT-DIC%2022.pdf"
      }
    ]
  }
  
  
  
]